(ns io.daskul.webapp.widgets.form.advanced-section
  "Progressive-disclosure form section: a collapsed-by-default \"More details\"
   accordion wrapping a subset of form fields (SMS-106).

   Used to slim a create/edit form by splitting its fields into a *primary* set
   (rendered inline, up front) and an *advanced* set (rendered inside a
   collapsed disclosure). Both the in-chat lookup-create form and the standalone
   panel-form share this widget; each call site declares its own advanced set.

   This namespace is layout only — the pure split seam lives in
   `io.daskul.webapp.widgets.form.advanced-fields` so it can be node-tested
   without pulling in UI/icon modules. `advanced-section` takes the already
   split advanced fields plus a caller-supplied `render-field` fn, so it stays
   agnostic about how any given form renders a field."
  (:require
   [uix.core :refer [defui $]]
   [io.daskul.webapp.ui :as ui]))

(defui advanced-section
  "Collapsed-by-default \"More details\" disclosure (wraps ui/accordion).

   Props:
   - fields:       vector of field maps to render inside the disclosure
   - render-field: (fn [field] hiccup) — caller renders one field; the returned
                   element MUST carry a :key
   - label:        disclosure label (default \"More details\")
   - item-value:   accordion item value (default \"more-details\")

   Renders nothing when `fields` is empty (so a form with no advanced fields
   shows no empty disclosure). The accordion is uncontrolled with no default
   open item, so it starts collapsed."
  [{:keys [fields render-field label item-value]
    :or {label "More details" item-value "more-details"}}]
  (when (seq fields)
    ($ ui/accordion {:variant "separated"
                     :chevronPosition "left"
                     :data-testid "advanced-section"}
       ($ ui/accordion-item {:value item-value}
          ($ ui/accordion-control {:data-testid "advanced-section-control"} label)
          ($ ui/accordion-panel
             ($ ui/stack {:gap "sm"}
                (for [field fields]
                  (render-field field))))))))
